import React from 'react';
import { CardHeader, styled } from '@mui/material';
import LoginTableRemote from 'src/components/LoginTableRemote';
import { TopWrapper } from 'src/components/OverviewComponents/CustomersList';
import Row from 'src/frontend-common/components/Row';
import SeeMoreLink from 'src/components/SeeMoreLink';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

const TopAndWorstLogin: React.FC<{ isTop: boolean; navigateTo: NavigateCallbackFn }> = ({ isTop, navigateTo }) => {
  return (
    <TopWrapper style={{ height: 'fit-content' }}>
      <CardHeader title={isTop ? 'Top Logins' : 'Worst Logins'} />
      <LoginTableRemote isTop={isTop} navigateTo={navigateTo} />
      <FlexEndRow testId="customer-list">
        <SeeMoreLink to={`/lookups/?tab=6`} />
      </FlexEndRow>
    </TopWrapper>
  );
};

export default TopAndWorstLogin;

export const FlexEndRow = styled(Row)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'flex-end',
}));
